import { Middleware } from "redux";
import { itineraryApi } from "./itineraryApi";
import GetCookie from "../../Common/Functions/GetCookie";
import { sortItinerary } from "../utils/sortItinerary";
import { Itinerary } from "../objects/itinerary";

// Every writer of the legacy itinerary_list (GetTrip, the itinerary page, the cart dates editors, product
// deletion...) dispatches ITINERARY_SET_ITINERARY_LIST with the list the server just returned. Mirror it
// into the getItinerary cache so the cart texts sync sees the same itinerary. A flush is deliberately NOT
// mirrored: the cache entry is keyed by trip/version and stays true for them while the trip reloads.
export const itineraryCacheSyncMiddleware: Middleware = (store) => (next) => (action) => {
    const result = next(action);
    if (action && action.type === 'ITINERARY_SET_ITINERARY_LIST') {
        // sorted like the getItinerary response
        const itinerary = [...(action.payload.itinerary_list as Itinerary[])].sort(sortItinerary);
        const firstStep = itinerary[0];
        // an empty list carries no trip/version of its own: it belongs to the trip loaded in the tab
        const tripId = firstStep ? firstStep.trip : parseInt(GetCookie('trip_id') || '0');
        const version = firstStep ? firstStep.trip_version : parseInt(GetCookie('trip_id_version') || '0');
        if (tripId && version) {
            store.dispatch(
                itineraryApi.util.upsertQueryData(
                    'getItinerary',
                    { tripId, version, tripToken: null },
                    itinerary
                ) as any
            );
        }
    }
    return result;
};
